module.exports = __webpack_public_path__ + "static/media/semble.9ccf88b9.webp";